module.exports = __webpack_public_path__ + "static/media/zapsplat_cartoon_bite_single_crunch_002_29057.b6bff1a7.mp3";